import axios from 'axios';
import { Message } from 'element-ui'
import { getCookie } from '@/utils/util.js';
import router from '@/router'
import { serverUrl } from '@/utils/server.js'
/**
 * axios实例
 */
console.log("serverUrl", serverUrl)
const request = axios.create({
  baseURL: serverUrl.baseURL,
  timeout: 10000,
  headers: {
  }
});

/**
 * 请求前添加token
 */
request.interceptors.request.use(function(config) {
  config.headers['token'] = getCookie('token') !== '' ? getCookie('token') : ''; // 获取token 也就是说在设置的时候也要设置成token
  config.headers['type']='admin'
  config.headers['website']='zx'
  if(config.url.indexOf('/customPage/export') != -1) {
		config.responseType ='blob'
	}
  return config;
});
export default request;
/**
 * 请求回来处理数据
 */
request.interceptors.response.use(function(res) {
  // console.log('=========' + JSON.stringify(res))
 //  if (res.config.url.indexOf('getQrCode') !== -1) {
 //    return res.request.response
 //  }
 //  if(res.config.url.indexOf('/customPage/export') != -1) {
	// 	return res
	// }
  // var result = JSON.parse(res.request.response);
  if ((res.status === 200 || res.status === 201) || res.status === 0) {
    return res.data;
  } else {
    // Message({
    //   message: result.message ? result.message : result.errmsg,
    //   type: 'warning'
    // });
    if (res.status === 401) {
      router.push({path: '/login'})
    }
    return Promise.reject(res);
  }
});

export function get(url,params){
  return request({
    url: url,
    method: 'get',
    data: params,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'website': 'zx'
    },
  });
}

export function post(url,params){
  return request({
    url: url,
    method: 'post',
    data: params,
    headers:{
      'Content-Type': 'application/json;charset=UTF-8',
      'website': 'zx'
    },
  });
}



// WEBPACK FOOTER //
// ./src/utils/request.js